export default __webpack_public_path__ + "static/media/ringtone.7846cf27.mp3";